import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import React, {useState} from 'react'
import {
  CountDownTimerSettings,
  createCountdown,
} from 'Event/Dashboard/components/CountDownTimer'
import TimerConfig from 'Event/template/SimpleBlog/Dashboard/CountDownTimers/CountDownTimer/TimerConfig'
import {useSimpleBlogTemplate} from 'Event/template/SimpleBlog'

export default function NewCountDownTimerButton(props: {className?: string}) {
  const [
    countDownTimer,
    setCountDownTimer,
  ] = useState<CountDownTimerSettings | null>(null)

  const {countDownTimers} = useSimpleBlogTemplate()

  const numCountdowns = Object.keys(countDownTimers).length

  const clearCountDownTimer = () => setCountDownTimer(null)

  const addCountDownTimer = () => {
    setCountDownTimer(createCountdown(numCountdowns + 1))
  }
  return (
    <>
      <NewCountDownTimerConfig
        timer={countDownTimer}
        onClose={clearCountDownTimer}
      />
      <Grid item xs={12} className={props.className}>
        <Button
          fullWidth
          size="large"
          variant="outlined"
          color="primary"
          aria-label="add count down timer"
          onClick={addCountDownTimer}
        >
          Add Countdown
        </Button>
      </Grid>
    </>
  )
}

function NewCountDownTimerConfig(props: {
  timer: CountDownTimerSettings | null
  onClose: () => void
}) {
  if (!props.timer) {
    return null
  }

  return (
    <TimerConfig showing onClose={props.onClose} countDownTimer={props.timer} />
  )
}
